import { render, staticRenderFns } from "./SingleCard.vue?vue&type=template&id=1c914132&"
import script from "./SingleCard.vue?vue&type=script&lang=js&"
export * from "./SingleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports